import React, { useState, useEffect } from "react";
import   "./desktopNavbar.scss";
import Link from "next/link";
import Image from "next/image";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import { usePathname } from "next/navigation";
import { animateScroll as scroll } from "react-scroll";

import CommingSoonModal from "@/components/modals/commingSoonModal";

import profile from "@/../public/profile/profile.png";
import { allRoutes } from "@/data/allRoutes";

export default function DesktopNavbar({
  setIsProfileOpen,
  isUserPresent,
  selector,
  path,
}) {
  const [showDropDown, setShowDropDown] = useState(false);
  const [showCommingSoonModal, setShowCommingSoonModal] = useState(false);
  const pathname = usePathname();

  const handleContactScroll = () => {
    if (selector.contact) {
      scroll.scrollTo(selector.contact.offsetTop - 20, {
        duration: 500,
        smooth: "easeInOutQuart",
      });
    }
  };

  return (
    <nav className="DesktopNavbar">
      {/* Pricing */}
      <Link href="/pricing" className="navLink">
        <span className="navLink span">Pricing</span>
      </Link>

      {/* Products */}
      <div className="navLink products">
        {/* <Link href={"/"} className={`${styles.navLink}`}> */}
        <span className="span">Products</span>
        {/* </Link> */}
        <ul className="productsHoverContainer">
          <Link href={allRoutes.headshotGenerator}>
            <li className="flex-row-center list">
              AI Headshot Generator
              <span className="newNavIcon">New</span>
            </li>
          </Link>
          <Link href={`${allRoutes.faceSwap}`}>
            <li className="list">AI Face Swap</li>
          </Link>
          <Link href={`${allRoutes.imageEnhancer}`}>
            <li className="list">AI Image Enhancer</li>
          </Link>
          <Link href={allRoutes.imageGenerator}>
            <li className="flex-row-center list">
              AI Image Generator
              <span className="newNavIcon">New</span>
            </li>
          </Link>
        </ul>
      </div>

      {/* Company */}
      <div className="navLink company">
        {/* <Link href={"/"} className={`${styles.navLink}`}> */}
        <span className="span">Company</span>
        {/* </Link> */}
        <ul className="companyHoverContainer">
          <Link href={"/about"}>
            <li className="flex-row-center list">About</li>
          </Link>
          <Link href={"/blogs"}>
            <li className="list">Blogs</li>
          </Link>

          {/* Legal Dropdown */}
          <div className="flex-col-center parent">
            <div onClick={() => setShowDropDown((prev) => !prev)}>
              <li className="flex-row-center list">
                Legal
                {showDropDown ? (
                  <RiArrowDropUpLine className="dropDownIcon" />
                ) : (
                  <RiArrowDropDownLine className="dropDownIcon" />
                )}
              </li>
            </div>
            {showDropDown && (
              <ul className="flex-col-center dropDownContainer">
                <Link href={"/refund-policy"}>
                  <li className="list">Refund Policy</li>
                </Link>
                <Link href={"/privacy-policy"}>
                  <li className="list">Privacy Policy</li>
                </Link>
                <Link href={"/terms-conditions"}>
                  <li className="list">Terms & Conditions</li>
                </Link>
              </ul>
            )}
          </div>

          <Link href={"/faq"}>
            <li className="list">FAQ</li>
          </Link>
          <Link href={"/#contact"}>
            <li className="list">Contact Us</li>
          </Link>
        </ul>
      </div>

      {/* chat with us */}
      {/*  <Link href={"/"} className={${styles.navLink} ${styles.span}}>
        Chat with Us
      </Link> */}

      {/* about*/}
      {/* <div className={${styles.navLink} ${styles.products}}>
        <Link href={"/about"} className={${styles.navLink}}>
          <span className={styles.span}>About</span>
        </Link>

        <ul className={styles.productsHoverContainer}>
          <div className={flex-col-center ${styles.parent}}>
            <div onClick={() => setShowDropDown(prev => !prev)}>
              <li className={flex-row-center ${styles.list}}>
                Legal{" "}
                {!showDropDown && (
                  <RiArrowDropDownLine className={styles.dropDownIcon} />
                )}
                {showDropDown && (
                  <RiArrowDropUpLine className={styles.dropDownIcon} />
                )}
              </li>
            </div>

            // comment down please
            // href={{
              // pathname: "/", query: {
                      // isScrollToContact: true,
                    // },
                // }} 

            {showDropDown && (
              <ul className={flex-col-center ${styles.dropDownContainer}}>
                {pathname !== "/" && pathname !== "/#contact" && (
                  <a href="/#contact">
                    <li className={styles.list}>Contact Us</li>
                  </a>
                )}

                // comment down please
                // <div onClick={handleContactScroll}>
                   // <li className={styles.list}>Contact Us</li>
                // </div>

                {(pathname === "/" || pathname === "/#contact") && (
                  <div onClick={handleContactScroll}>
                    <li className={styles.list}>Contact Us</li>
                  </div>
                )}

                <Link href={"/privacy-policy"}>
                  <li className={styles.list}>Privacy Policy</li>
                </Link>
              </ul>
            )}
          </div>

          <Link href={"/faq"}>
            <li className={styles.list}>FAQ</li>
          </Link>
        </ul>
      </div> */}

      {/* Coming Soon Modal */}
      {showCommingSoonModal && (
        <CommingSoonModal
          showCommingSoonModal={showCommingSoonModal}
          setShowCommingSoonModal={setShowCommingSoonModal}
        />
      )}
    </nav>
  );
}
